import { getProcedureResult } from 'iguazu-rpc';
import { ELIGIBLE_MARKETS } from '../constants';
import { getMappedAccountsWithMarkets, getOrigin } from '../selectors';
import { makeEligibilityArgs } from '../utils';
const getCredoEligibility = (state, feature) => {
  const origin = getOrigin(state);
  const isEligibleFalse = {
    isEligible: false
  };
  const {
    markets,
    mappedAccounts
  } = getMappedAccountsWithMarkets(state);
  // eslint-disable-next-line no-restricted-syntax -- mutual exclusive rules
  for (const market of markets) {
    if (!ELIGIBLE_MARKETS[market.toLowerCase()]) {
      return isEligibleFalse;
    }
  }
  const eligibilityResponse = getProcedureResult({
    procedureName: 'readFeatureEligibilityForAccountV1',
    args: makeEligibilityArgs({
      origin,
      mappedAccounts,
      feature
    })
  })(state);
  if (eligibilityResponse instanceof Error) {
    return {
      ...isEligibleFalse,
      error: eligibilityResponse
    };
  }
  return eligibilityResponse || {};
};
export default getCredoEligibility;